import { render } from "./customizeForm.vue?vue&type=template&id=6b8ceb44&scoped=true"
import script from "./customizeForm.vue?vue&type=script&lang=js"
export * from "./customizeForm.vue?vue&type=script&lang=js"

import "./customizeForm.vue?vue&type=style&index=0&id=6b8ceb44&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8ceb44"]])

export default __exports__